import React from "react";
import { Bar, BarChart, XAxis, YAxis } from "recharts";

import { Card, CardContent } from "@/components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";

const LandFill = (): React.JSX.Element => {
  const chartData = [
    { month: "January", desktop: 60, mobile: 40 },
    { month: "February", desktop: 70, mobile: 30 },
    { month: "March", desktop: 65, mobile: 35 },
    { month: "April", desktop: 75, mobile: 25 },
    { month: "May", desktop: 90, mobile: 10 },
    { month: "June", desktop: 68, mobile: 32 },
    { month: "July", desktop: 72, mobile: 28 },
    { month: "August", desktop: 85, mobile: 15 },
    { month: "September", desktop: 62, mobile: 38 },
    { month: "October", desktop: 70, mobile: 30 },
    { month: "November", desktop: 67, mobile: 33 },
    { month: "December", desktop: 75, mobile: 25 },
  ];

  const colors = {
    desktop: "#224092",
    mobile: "#375BFB40",
  };

  const chartConfig = {
    desktop: {
      label: "Landfill %",
      color: colors.desktop,
    },
    mobile: {
      label: "Recycle %",
      color: colors.mobile,
    },
  } satisfies ChartConfig;

  return (
    <section className='flex flex-col gap-2 max-w-[80%]'>
      <Card>
        <CardContent>
          <h2 className='my-4 font-medium'>Landfill Diverse Tab</h2>
          <ChartContainer config={chartConfig} className='w-full h-[350px]'>
            <BarChart accessibilityLayer data={chartData}>
              <XAxis
                dataKey='month'
                tickLine={false}
                tickMargin={10}
                axisLine={false}
                tickFormatter={(value) => value.slice(0, 3)}
              />
              <YAxis
                orientation='left'
                tickCount={6}
                tickLine={false}
                tickMargin={10}
                axisLine={false}
                tickFormatter={(value) => `${value}%`}
              />

              <ChartTooltip content={<ChartTooltipContent hideLabel />} />

              <Bar
                dataKey='desktop'
                stackId='a'
                fill={colors.desktop}
                barSize={30}
                radius={[2, 2, 0, 0]}
              />

              <Bar
                dataKey='mobile'
                stackId='a'
                fill={colors.mobile}
                radius={[8, 8, 0, 0]}
              />
            </BarChart>
          </ChartContainer>
        </CardContent>
      </Card>
    </section>
  );
};

export default LandFill;
